import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a00198c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-token-add-to-cart" }
const _hoisted_2 = { class: "m-token-add-to-cart-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "m-token-add-to-cart-info" }
const _hoisted_5 = { class: "m-token-add-to-cart-name" }
const _hoisted_6 = { class: "m-token-add-to-cart-token-id" }
const _hoisted_7 = {
  key: 0,
  href: "https://delegate.cash/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_image = _resolveComponent("lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.token.image)
        ? (_openBlock(), _createBlock(_component_lazy_image, {
            key: 0,
            src: _ctx.token.image
          }, null, 8, ["src"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.brokenImageIcon
          }, null, 8, _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.token.name || 'Token Name'), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.token.tokenId || 'Token ID'), 1),
      (
          _ctx.token.eip5131 ||
          _ctx.token.eip5639 ||
          (_ctx.token.delegateAddress && _ctx.token.delegateAddress !== _ctx.token.ownerAddress)
        )
        ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
            _createElementVNode("img", {
              class: "m-token-add-to-cart-delegate-cash-icon",
              src: _ctx.delegateCashIcon
            }, null, 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}